import axios from 'axios'
// import store from '../store'
import { getToken, setToken, getId, removeToken } from './auth'
import { Message, Loading } from 'element-ui'
import _ from 'lodash'
import { logout } from './logout'

const whiteList = ['/pc-search', '/home/course', '/web/slides', '/pc/login']
// 创建普通请求axios实例
const request = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 30000 // 请求超时时间
})

// 发送请求提示弹窗节流
// loading
let loading
let currentRequestNum = 0
request.interceptors.request.use(
  config => {
    currentRequestNum++
    // 判断白名单
    let noWhite = true
    whiteList.forEach(ele => {
      if (config.url.indexOf(ele) !== -1) {
        noWhite = false
      } else if (!getToken()) {
      }
    })
    // 结束请求的
    if (!getToken() && noWhite) {
      // 多个请求中的第一个
      if (flag1) {
        Message.error('请先进行登录')
        logout(true)
        flag1 = false
        setTimeout(() => {
          flag1 = true
        }, 5000)
      }
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject()
      // 发请求
    } else {
      // 设置请求头
      if (getId()) {
        config.headers['userId'] = getId()
      }
      config.headers['token'] = getToken()
      config.headers['flag'] = 1
      // 记录观看时间的请求
      if (config.url.includes('courserecord')) {
      } else {
        if (currentRequestNum === 1 && !loading) {
          loading = Loading.service({
            fullscreen: true,
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          })
        }
      }
      return config
    }
  },
  error => {
    console.log(error)
  }
)
let flag = true
let flag1 = true
let invalidFlag = true

var toHideLoading = _.debounce(() => {
  loading.close()
  loading = null
}, 500)
request.interceptors.response.use(
  response => {
    currentRequestNum--
    currentRequestNum = Math.max(currentRequestNum, 0)
    if (currentRequestNum === 0 && loading) {
      toHideLoading()
    }
    const res = response.data
    if (response.headers['token-expire']) {
      var expireTime = response.headers['token-expire']
      if (res.data.token) {
        setToken(res.data.token, expireTime)
      } else {
        setToken(getToken(), expireTime)
      }
    }

    if (res.code === 40003 && flag1 === true) {
      Message({
        type: 'error',
        message: '登录超时，' + res.message
      })
      flag1 = false
      setTimeout(() => {
        flag1 = true
      }, 5000)
      removeToken()
      logout(true)
    } else if (res.code === 200) {
      return res
    } else if (res.code !== 40003 && res.code !== 200 && flag) {
      Message({
        type: 'error',
        message: res.message
      })
      flag = false
      setTimeout(() => {
        flag = true
      }, 5000)
    }
  },
  error => {
    currentRequestNum--
    currentRequestNum = Math.max(currentRequestNum, 0)
    if (currentRequestNum === 0 && loading) {
      toHideLoading()
    }
    if (invalidFlag && error) {
      Message({
        type: 'error',
        message: '系统异常，请稍后重试'
      })
      invalidFlag = false
      setTimeout(() => {
        invalidFlag = true
      }, 5000)
    }
    return Promise.reject(error)
  }
)

// 创建资源请求axios实例
const requestForAssets = axios.create({
  baseURL: process.env.ASSETS_PATH, // api 的 base_url
  timeout: 5000 // 请求超时时间
})

// 创建压缩资源请求axios实例
const requestForCompressedAssets = axios.create({
  baseURL: process.env.ASSETS_PATH, // api 的 base_url
  timeout: 5000 // 请求超时时间
})

// 创建一般请求
const rawRequest = axios.create({
  timeout: 5000 // 请求超时时间
})

export { request, requestForAssets, requestForCompressedAssets, rawRequest }



// WEBPACK FOOTER //
// ./src/utils/request.js